import React, { useMemo, useState, useCallback, useEffect } from 'react'
import style from "./index.module.scss"
import BaseLayout from 'layouts/base-layout/BaseLayout'
import VipExplain from './VipExplain'
import RechargeList from './RechargeList'
import RechargeCard from './rechargeCard'
import { clearLoginInfo } from "service/sign"
import ModelFn from "components/model/ModelFn"
import { RouterPaths } from 'utils/constant'
import { isMobile } from 'utils/utils'

const Recharge: React.FC = () => {
  const [isCDKey, setisCDKey] = useState(false)
  const [useCode, setuseCode] = useState(true)
  const [Complete, setComplete] = useState(false) 
  const [hideusecode, sethideusecode] = useState(true) 
  const [checkoutCoupon, setcheckoutCoupon] = useState(true) 
  const [hint, sethint] = useState(null)


  const cdkey = useCallback((params) => {
    if (localStorage.UserInfo) {
      setisCDKey(params)
    } else {
      clearLoginInfo()
      ModelFn.confirm({
        text: "请先登录穿梭账号",
        onConfirm: () => { isMobile() ? window.location.replace(RouterPaths["signin-phone"]) : window.location.replace(RouterPaths["signin-qr"]) },
        noCancel: true
      })
    }

  }, [])

  const handleScroll = () => {
    function scrollToBottom() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop // 滚动条偏移量
      //超过300自动跳转到800 
      if (scrollTop >= 500) { 
        window.scrollTo({ 
          top: 1200, 
          behavior: "smooth" 
        })
        window.removeEventListener('scroll', scrollToBottom)
      }
    }
    window.addEventListener('scroll', scrollToBottom) 
  }


  useEffect(() => {  
    document.body.clientWidth<767 &&  handleScroll() 
  }, [])


  return useMemo(() => (
    <BaseLayout>
      <div className={style.recharge}>
        <VipExplain />
        <RechargeList setcheckoutCoupon={setcheckoutCoupon} checkoutCoupon={checkoutCoupon}  setselect={cdkey} select={isCDKey} setuseCode={setuseCode} setComplete={setComplete} sethints={sethint} sethideusecode={sethideusecode} />
        {isCDKey || <RechargeCard setcheckoutCoupon={setcheckoutCoupon} checkoutCoupon={checkoutCoupon} useCode={useCode} Complete={Complete} hint={hint} setuseCode={setuseCode} setComplete={setComplete} sethint={sethint} sethideusecode={sethideusecode} hideusecode={hideusecode} />}
      </div>
    </BaseLayout>
  ), [isCDKey, cdkey, useCode, Complete, hint,sethideusecode,hideusecode,setcheckoutCoupon,checkoutCoupon])
}

export default Recharge
